export default __webpack_public_path__ + "static/media/6_Still.ef8cfc06.jpg";